import styled, { css } from 'styled-components';

import { rem } from '../../utils';

export const StyledWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${rem(theme.Spacing.Size.Small)};
  `
);
